<template>
  <div id="registration-setup-page">
    <h5 class="m-4 page-header"> >> {{ $t('PAGES.REGISTRATIONSETUP.REGISTER_WIZARD') }}</h5>

    <memlist-card>

      <div class="ml-tabs">
        <div class="ml-tabs-header">
          <button
            type="button"
            v-for="(tab, i) in tabs"
            :key="i"
            :class="['ml-tab-button', active_tab === i ? 'active' : '']"
            @click="active_tab = i"
            :disabled="tab.disabled"
          >
            {{ $t(tab.label) }}
          </button>
        </div>

        <div class="ml-tabs-body">
          <div v-show="active_tab === 0">
            <RegistrationPagesTab 
            />
          </div>
          <div v-show="active_tab === 1">
            <RegistrationSettingsTab 
          
            />
          </div>
        </div>
      </div>
    </memlist-card>
    
  </div>
</template>

<style lang="scss" scoped>

input[disabled] + span {
  background-color: #dddddd !important;
}

.infobox {
  border: 1px solid gray;
  padding: 8px;
  float: left;
}


.register-css-box > * {
  float: left;
  margin-right: 8px;
  margin-top: 8px;
}

</style>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { get_domain_url, get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import RightSaveButton from '@/view/components/buttons/RightSaveButton.vue';

import RegistrationPagesTab from './registrationsetup/RegistrationPagesTab.vue';
import RegistrationSettingsTab from './registrationsetup/RegistrationSettingsTab.vue';

export default {
  name: 'RegistrationSetupPage',
  mixins: [ toasts ],
  components: {
    RightSaveButton,
    RegistrationSettingsTab,
    RegistrationPagesTab
  },
  computed: {
    tabs() {
      let base = [
        { label: 'PAGES.REGISTRATION.PAGES', disabled: false },
        { label: 'COMMON.SETTINGS', disabled: false },
      ];

      return base;
    },

    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods', 'companies'])
  },
  mounted() {
    
  },
  data() {
    return {
      active_tab: 0,
    };
  },

  watch: {
    currentCompanyId(newValue, oldvalue) {
      if (newValue) {
    
      }
    },
    
  },

  methods: {

  }
};
</script>
